import React, { Component } from 'react';
import { AccentColor } from 'helpers/AccentColorHelper';
import FlatButton from 'material-ui/FlatButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import withMobileDialog from '@material-ui/core/withMobileDialog';

class LoginHelpDialog extends Component {
  render() {
    return (
      <Dialog
        fullScreen={this.props.fullScreen}
        open={this.props.isOpen}
        onClose={this.props.handleClose}
        aria-labelledby="login-help"
      >
        <DialogTitle id="add-new-template" onClose={this.props.handleClose}>
          <h3 style={{ textAlign: 'center', margin: 0 }}>
            {getTranslatedString('loginHelp.loginHelp')}
          </h3>
        </DialogTitle>
        <DialogContent>{this.renderDialogContent()}</DialogContent>
        <DialogActions style={{ display: 'block' }}>
          <FlatButton
            onClick={this.props.handleClose}
            id="close-button"
            style={{
              color: AccentColor(),
              float: 'right',
              padding: '0px 15px',
            }}
          >
            {getTranslatedString('loginHelp.close')}
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  }

  renderDialogContent = () => {
    const { stage, loginMessage } = this.props;
    if (
      stage === 'login' &&
      (loginMessage === 'residentLoginPortal' || loginMessage === 'tenantLoginPortal')
    )
      return this.renderLoginTenant();
    if (stage === 'login' && loginMessage === 'landlordLoginPortal')
      return this.renderLoginLandlord();
    if (stage === 'validateMobileNumber') return this.renderValidateMobileNumber();
    if (stage === 'verificationCode') return this.renderVerificationCode();
    if (stage === 'alternative') return this.renderAlternative();
    if (stage === 'passwordExpired') return this.renderPasswordExpired();
  };

  renderLoginTenant = () => {
    let landlordVerbiage = getTranslatedString('landlord');
    if (
      this.props.verbiages &&
      this.props.verbiages.landlord &&
      this.props.verbiages.landlord[getCurrentLocale()]
    ) {
      landlordVerbiage = this.props.verbiages.landlord[getCurrentLocale()];
    }

    return (
      <div>
        <h4>{getTranslatedString('loginHelp.iCantLogin')}</h4>
        <p>
          {getTranslatedString('loginHelp.verifyEmail', {
            landlordVerbiage: landlordVerbiage,
          })}
        </p>
        <h4>{getTranslatedString('loginHelp.accountLocked')}</h4>
        <p>
          {getTranslatedString('loginHelp.accountLockedDetails')}{' '}
          <a
            href={`${this.props.passwordResetURL}`}
            aria-label={getTranslatedString('loginHelp.accountLockedDetails')}
          >
            {getTranslatedString('loginHelp.here')}
          </a>.
        </p>
        <h4>{getTranslatedString('loginHelp.unconfirmed')}</h4>
        <p>
          {getTranslatedString('loginHelp.accountNotActivated', {
            landlordVerbiage: landlordVerbiage,
          })}
        </p>
      </div>
    );
  };

  renderLoginLandlord = () => {
    return (
      <div>
        <h4>{getTranslatedString('loginHelp.iCantLogin')}</h4>
        <p>{getTranslatedString('loginHelp.verifyEmailLandlord')}</p>
        <h4>{getTranslatedString('loginHelp.accountLocked')}</h4>
        <p>
          {getTranslatedString('loginHelp.accountLockedDetails')}{' '}
          <a
            href={`${this.props.passwordResetURL}`}
            aria-label={getTranslatedString('loginHelp.accountLockedDetails')}
          >
            {getTranslatedString('loginHelp.here')}
          </a>.
        </p>
        <h4>{getTranslatedString('loginHelp.unconfirmed')}</h4>
        <p>{getTranslatedString('loginHelp.accountNotActivatedLandlord')}</p>
      </div>
    );
  };

  renderValidateMobileNumber = () => {
    return (
      <div>
        <h4>{getTranslatedString('loginHelp.validatePhone')}</h4>
        <p>{getTranslatedString('loginHelp.twoFactor')}</p>
        <h4>{getTranslatedString('loginHelp.canChangeNumber')}</h4>
        <p>{getTranslatedString('loginHelp.canChangeNumberYes')}</p>
        <h4>{getTranslatedString('loginHelp.doINeedCell')}</h4>
        <p>{getTranslatedString('loginHelp.doINeedCellNo')}</p>
      </div>
    );
  };

  renderVerificationCode = () => {
    return (
      <div>
        <h4>{getTranslatedString('loginHelp.verificationCode')}</h4>
        <p>{getTranslatedString('loginHelp.sentVerificationCode')}</p>
        <h4>{getTranslatedString('loginHelp.dontHavePhone')}</h4>
        <p>{getTranslatedString('loginHelp.alternateMethod')}</p>
        <h4>{getTranslatedString('loginHelp.didntReceiveCode')}</h4>
        <p>{getTranslatedString('loginHelp.tryAgain')}</p>
      </div>
    );
  };

  renderAlternative = () => {
    return (
      <div>
        <h4>{getTranslatedString('loginHelp.secondStep')}</h4>
        <p>{getTranslatedString('loginHelp.twoFactorTurnedOn')}</p>
        <h4>{getTranslatedString('loginHelp.changedPhone')}</h4>
        <p>{getTranslatedString('loginHelp.followEmail')}</p>
        <h4>{getTranslatedString('loginHelp.emailAccess')}</h4>
        <p>{getTranslatedString('loginHelp.followText')}</p>
      </div>
    );
  };

  renderPasswordExpired = () => {
    return (
      <div>
        <h4>{getTranslatedString('loginHelp.resetPassword')}</h4>
        <p>{getTranslatedString('loginHelp.expired')}</p>
        <h4>{getTranslatedString('loginHelp.reset')}</h4>
        <p>{getTranslatedString('loginHelp.clickReset')}</p>
      </div>
    );
  };
}

export default withMobileDialog()(LoginHelpDialog);
